import type { ReactNode } from 'react'
import { TON, type Ton } from './TonuriB4L'
import { Explicatie } from './Explicatie'

/**
 * Cardul cu o cifra, acelasi in tot CRM-ul. Inlocuieste, pe rand, cele 13 variante de „KPI"
 * scrise separat prin pagini.
 *
 * Culoarea spune ce fel de cifra e (vezi `docs/design.md`): verde = gata / bani incasati,
 * albastru = in curs / informativ, galben = de verificat, rosu = problema, mov = oameni,
 * gri = neutru. Nu se alege dupa gust.
 *
 * Cu `onClick`, cardul devine selector (deschide lista lui, ca pe Rambursuri curieri) si
 * `selectat` il scoate in evidenta.
 */
export function CardCifra({
  ton = 'gri',
  eticheta,
  valoare,
  detaliu,
  explicatie,
  onClick,
  selectat = false,
}: {
  ton?: Ton
  eticheta: string
  valoare: ReactNode
  detaliu?: ReactNode
  /** La hover pe eticheta — pentru o cifra al carei sens nu reiese din nume. */
  explicatie?: ReactNode
  onClick?: () => void
  selectat?: boolean
}) {
  const t = TON[ton]
  const continut = (
    <>
      <span className={`text-eticheta uppercase ${t.text}`}>
        {explicatie ? (
          <Explicatie text={explicatie} focalizabil={!onClick}>
            {eticheta}
          </Explicatie>
        ) : (
          eticheta
        )}
      </span>
      <span className="text-titlu tabular-nums text-b4l-text">{valoare}</span>
      {detaliu && <span className="text-mic text-b4l-text-muted">{detaliu}</span>}
    </>
  )
  // un singur fundal pe card: doua clase `bg-*` se bat, si castiga cea scrisa mai tarziu in CSS
  const fundal = selectat ? t.fundal : 'bg-b4l-surface'
  const clase = `grid content-start gap-1 rounded-caseta border border-l-4 border-b4l-border p-3 text-left ${t.bara} ${fundal}`
  if (!onClick) return <div className={clase}>{continut}</div>
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={selectat}
      className={`${clase} transition hover:shadow-ridicat focus-visible:outline focus-visible:outline-2 focus-visible:outline-b4l-blue ${
        selectat ? `ring-2 ${t.contur}` : ''
      }`}
    >
      {continut}
    </button>
  )
}
